import { call, put, takeEvery } from "redux-saga/effects";
import * as UserActions from "./user.actions";
import * as ShoppingActions from "../shopping/shopping.actions";
import UserAPI from "./user.api";
import { UserActionTypes } from "./user.model";
import { clearToken, IsNullOrEmpty } from "../../helpers/utility";
import Swal from "sweetalert2";

export function* handlePreSignUpPhone(action) {
    try {
        const response = yield call(UserAPI.PreSignUpPhone, action.payload);
        yield put(UserActions.preSignUpPhoneSuccess(response));
        Swal.fire({
            title: "OTP sent",
            text: "A verification code has been sent to your phone",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(UserActions.preSignUpPhoneFailure(e));
    }
}

export function* handleSignUpPhone(action) {
    try {
        const response = yield call(UserAPI.SignUpPhone, action.payload);
        yield put(UserActions.signUpPhoneSuccess(response));
        Swal.fire({
            title: "Registration",
            text: "You have been registered",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(UserActions.signUpPhoneFailure(e));
    }
}

export function* handlePreSignUpEmail(action) {
    try {
        const response = yield call(UserAPI.PreSignUpEmail, action.payload);
        yield put(UserActions.preSignUpEmailSuccess(response));
        Swal.fire({
            title: "OTP sent",
            text: "A verification code has been sent to your email",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(UserActions.preSignUpEmailFailure(e));
    }
}

export function* handleSignUpEmail(action) {
    try {
        const response = yield call(UserAPI.SignUp, action.payload);
        yield put(UserActions.signUpEmailSuccess(response));
        Swal.fire({
            title: "Registration",
            text: "You have been registered",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(UserActions.signUpEmailFailure(e));
    }
}

export function* handleGoogleLogin(action) {
    try {
        const response = yield call(UserAPI.SignInGoogle, action.payload);
        yield put(UserActions.loginGoogleSuccess(response));
        yield put(UserActions.fetchUserProfileRequest({}));
    } catch (e) {
        yield put(UserActions.loginGoogleFailure(e));
    }
}

export function* handleTwitterLogin(action) {
    try {
        const response = yield call(UserAPI.SignInTwitter, action.payload);
        yield put(UserActions.loginTwitterSuccess(response));
        yield put(UserActions.fetchUserProfileRequest({}));
    } catch (e) {
        yield put(UserActions.loginTwitterFailure(e));
    }
}

export function* handleloginPassword(action) {
    try {
        const response = yield call(UserAPI.SignInPassword, action.payload);
        yield put(UserActions.loginPasswordSuccess(response));
        yield put(UserActions.fetchUserProfileRequest({}));
    } catch (e) {
        yield put(UserActions.loginPasswordFailure(e.response.data.message));
    }
}

export function* handleFetchUserProfile(action) {
    try {
        const response = yield call(UserAPI.GetUserProfile, action.payload);
        yield put(UserActions.fetchUserProfileSuccess(response));
        yield put(ShoppingActions.fetchPaymentConfigRequest());
    } catch (e) {
        yield put(UserActions.fetchUserProfileFailure(e));
    }
}

export function* handleUpdateUserProfile(action) {
    try {
        const response = yield call(
            UserAPI.UpdateUserProfile,
            action.payload.req
        );
        yield put(UserActions.updateUserProfileSuccess(response));
        Swal.fire({
            title: "Profile updated",
            text: "Your new profile changes have been updated successfully.",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "grey",
            confirmButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
        yield put(UserActions.fetchUserProfileRequest());
    } catch (e) {
        yield put(UserActions.updateUserProfileFailure(e));
    }
}

export function* handleSendOTP(action) {
    try {
        const response = yield call(UserAPI.SendOTP, action.payload);
        yield put(UserActions.sendOTPSuccess(response));
        Swal.fire({
            title: "OTP sent",
            text: "A verification code has been sent to your email / phone",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(UserActions.sendOTPFailure(e));
    }
}

export function* handleSearchUser(action) {
    try {
        const response = yield call(UserAPI.SearchUser, action.payload);
        yield put(UserActions.searchUserSuccess(response));
    } catch (e) {
        yield put(UserActions.searchUserFailure(e));
    }
}
export function* handleCheckUser(action) {
    try {
        const response = yield call(UserAPI.CheckUser, action.payload);

        if (IsNullOrEmpty(response.data)) {
            yield put(UserActions.CheckUserSuccess({ data: "@@@NA###" }));
        } else {
            yield put(UserActions.CheckUserSuccess(response));
        }
    } catch (e) {
        yield put(UserActions.CheckUserFailure(e));
    }
}
export function* handleFollowUser(action) {
    try {
        const response = yield call(UserAPI.FollowUser, action.payload);
        yield put(UserActions.followUserSuccess(response));
        // Swal.fire({
        //     title: 'Follow User',
        //     text: "User Followed Successfully",
        //     icon: 'success',
        //     showCancelButton: true,
        //     confirmButtonColor: '#3085d6',
        //     cancelButtonColor: '#d33',
        //     showConfirmButton: false,
        //     cancelButtonText: "Close"
        // });
        yield put(UserActions.searchUserRequest());
        yield put(UserActions.fetchUserProfileRequest());
        //yield put(UserActions.fetchOtherUserProfileRequest(action.payload.following));
        yield put(UserActions.fetchFollowerUserRequest());
    } catch (e) {
        yield put(UserActions.followUserFailure(e));
    }
}

export function* handleUnFollowUser(action) {
    try {
        const response = yield call(UserAPI.UnFollowUser, action.payload);
        // Swal.fire({
        //     title: 'UnFollow User',
        //     text: "User Unfollowed Successfully",
        //     icon: 'success',
        //     showCancelButton: true,
        //     confirmButtonColor: '#3085d6',
        //     cancelButtonColor: '#d33',
        //     showConfirmButton: false,
        //     cancelButtonText: "Close"
        // });
        yield put(UserActions.unfollowUserSuccess(response));
        yield put(UserActions.fetchUserProfileRequest());
        //yield put(UserActions.fetchOtherUserProfileRequest(action.payload.following));
        yield put(UserActions.searchUserRequest());
        yield put(UserActions.fetchFollowerUserRequest());
    } catch (e) {
        yield put(UserActions.unfollowUserFailure(e));
    }
}

export function* handlefolloweruser(action) {
    try {
        const response = yield call(UserAPI.GetFollowersList, action.payload);
        yield put(UserActions.fetchFollowerUserSuccess(response));
    } catch (e) {
        yield put(UserActions.fetchFollowerUserFailure(e));
    }
}

export function* handlesubscriberlist(action) {
    try {
        const response = yield call(UserAPI.ListSubscriber, action.payload);
        yield put(UserActions.fetchSubscriberListSuccess(response));
    } catch (e) {
        yield put(UserActions.fetchSubscriberListFailure(e));
    }
}

export function* handleFetchSubscriptions(action) {
    try {
        const response = yield call(
            UserAPI.ListMySubscriptions,
            action.payload
        );
        yield put(UserActions.getMySubscriptionsSuccess(response));
    } catch (e) {
        yield put(UserActions.getMySubscriptionsFailure(e));
    }
}

export function* handleChangePassword(action) {
    try {
        const response = yield call(UserAPI.ChangePassword, action.payload);
        yield put(UserActions.changePasswordSuccess(response));
        Swal.fire({
            title: "Change Password",
            text: "Password Changed Successfully",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        yield put(UserActions.changePasswordFailure(e));
    }
}

export function* handleForgotPassword(action) {
    try {
        const response = yield call(UserAPI.ForgotPasword, action.payload);
        yield put(UserActions.forgotPasswordSuccess(response));
        document.location.href = process.env.PUBLIC_URL + "/login";
        Swal.fire({
            title: "Change Password",
            text: "Password Changed Successfully",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
    } catch (e) {
        Swal.fire({
            title: "Change Password",
            text: e.response.data.message,
            icon: "error",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Close",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        });
        yield put(UserActions.forgotPasswordFailure(e));
    }
}

export function* handleFetchOtherProfile(action) {
    try {
        const response = yield call(
            UserAPI.GetOtherProfileById,
            action.payload.id
        );
        response.data.id = action.payload.id;
        yield put(UserActions.fetchOtherUserProfileSuccess(response));
        if (action.payload.history) {
            action.payload.history("/" + response.data.userName, {
                state: {
                    shop: "",
                },
            });
        }
    } catch (e) {
        yield put(UserActions.fetchOtherUserProfileFailure(e));
    }
}

export function* handleAddRefer(action) {
    try {
        const response = yield call(UserAPI.AddReferralCode, action.payload);
        yield put(UserActions.addReferralCodeSuccess(response));
        yield put(UserActions.fetchUserProfileRequest());
        Swal.fire({
            title: "Referral",
            text: "Account Updated to PRO Successfully.Please login again",
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            showConfirmButton: false,
            cancelButtonText: "Done",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        }).then((x) => {
            if (x.isDismissed) {
                clearToken();
                document.location.href = "/login";
            }
        });
    } catch (e) {
        yield put(UserActions.addReferralCodeFailure(e));
    }
}

export function* UserSaga() {
    yield takeEvery(
        UserActionTypes.PRESIGNUP_PHONE_REQUEST,
        handlePreSignUpPhone
    );
    yield takeEvery(UserActionTypes.SIGNUP_PHONE_REQUEST, handleSignUpPhone);
    yield takeEvery(
        UserActionTypes.PRESIGNUP_EMAIL_REQUEST,
        handlePreSignUpEmail
    );
    yield takeEvery(UserActionTypes.SIGNUP_EMAIL_REQUEST, handleSignUpEmail);
    yield takeEvery(UserActionTypes.LOGIN_GOOGLE_REQUEST, handleGoogleLogin);
    yield takeEvery(UserActionTypes.LOGIN_TWITTER_REQUEST, handleTwitterLogin);
    yield takeEvery(
        UserActionTypes.LOGIN_PASSWORD_REQUEST,
        handleloginPassword
    );
    yield takeEvery(
        UserActionTypes.CHANGE_PASSWORD_REQUEST,
        handleChangePassword
    );
    yield takeEvery(
        UserActionTypes.FORGOT_PASSWORD_REQUEST,
        handleForgotPassword
    );
    yield takeEvery(
        UserActionTypes.FETCH_USER_PROFILE_REQUEST,
        handleFetchUserProfile
    );
    yield takeEvery(
        UserActionTypes.UPDATE_USER_PROFILE_REQUEST,
        handleUpdateUserProfile
    );
    yield takeEvery(UserActionTypes.SEND_OTP_REQUEST, handleSendOTP);
    yield takeEvery(UserActionTypes.SEARCH_USER_REQUEST, handleSearchUser);
    yield takeEvery(UserActionTypes.FOLLOW_USER_REQUEST, handleFollowUser);
    yield takeEvery(UserActionTypes.UNFOLLOW_USER_REQUEST, handleUnFollowUser);
    yield takeEvery(
        UserActionTypes.FETCH_FOLLOWER_USER_REQUEST,
        handlefolloweruser
    );
    yield takeEvery(
        UserActionTypes.FETCH_SUBSCRIBER_LIST_REQUEST,
        handlesubscriberlist
    );
    yield takeEvery(
        UserActionTypes.FETCH_OTHER_PROFILE_REQUEST,
        handleFetchOtherProfile
    );
    yield takeEvery(UserActionTypes.ADD_REFER_CODE_REQUEST, handleAddRefer);
    yield takeEvery(UserActionTypes.CHECK_USER_REQUEST, handleCheckUser);
    yield takeEvery(
        UserActionTypes.FETCH_MY_SUBSCRIPTIONS_REQUEST,
        handleFetchSubscriptions
    );
}
